module.exports = __webpack_public_path__ + "static/img/win_prize.a5ceb2c.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/408/win_prize.png
// module id = 491
// module chunks = 1